import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';

import { Select } from 'sabre-spark-react';
import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import ReactSparkTextInput from '../widgets/ReactSparkTextInput';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';
import { formatBytes } from '../../../lib/utils';
import { checkPermissions } from '../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../constants/AccessPoints';

class PagesCustomFonts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fontfamily: '',
            fontweight: '',
            fontstyle: ''
        };
    }

    /**
     * Formats footer for grid/list view
     * @param asset
     * @returns {XML}
     */
    footerFormatter(asset) {
        if (asset.category !== CATEGORIES.FONT) return null;
        const metadata = JSON.parse(get(asset, 'metadata.Value', '{}'));
        const weight = get(metadata, 'fontweight.weight', '');
        const style = get(metadata, 'fontstyle.style', '');
        const filename = get(asset, 'filename', '');
        const format = filename.split('.').splice(-1);

        return (
            <div>
                {weight && `${weight} | `}
                {style && `Style: ${style}`}
                {format && ` | Format: ${format}`}
                {asset.size && ` | Size: ${formatBytes(asset.size)}`}
            </div>
        );
    }

    validateAccess() {
        const { hasAccessThemes, hasAccessCustomContent } = this.props;
        const { fontstyle, fontweight, fontfamily } = this.state;

        const hasAccessToAddThemesAndCustomContent = hasAccessThemes.add || hasAccessCustomContent.add;
        const hasNoNullValues = fontstyle && fontweight && fontfamily;

        return !!(hasAccessToAddThemesAndCustomContent && hasNoNullValues);
    }

    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    render() {
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Custom Fonts</h1>
                <p className="normal-text">
                    Upload custom fonts file(s) You can upload any web fonts and they will be added to the font family
                    list. For maximum browser support upload TTF, OTF, EOT and WOFF.
                </p>
                {!(this.state.fontstyle && this.state.fontweight && this.state.fontfamily) && (
                    <div className="spark-panel col-xs-12">
                        <div className="spark-panel__content">
                            <div className="spark-message spark-message--warning">
                                <i className="spark-message__icon spark-icon-alert-triangle spark-icon--fill"></i>
                                <p className="spark-message__content">
                                    <b>Font family, font style and font weight cannot be null</b>
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <br />
                {(this.props.hasAccessThemes.add || this.props.hasAccessCustomContent.add) && (
                    <div className="row">
                        <div className="col-md-4">
                            <ReactSparkTextInput
                                label="Font family"
                                value={this.state.fontfamily}
                                onChange={e =>
                                    this.setState({
                                        fontfamily: e.target.value
                                    })
                                }
                            />
                        </div>
                        <div className="col-md-4">
                            <Select
                                label="Font style"
                                defaultValue={this.state.fontstyle}
                                options={['Normal', 'Bold', 'Italic', 'BoldItalic'].map(v => {
                                    return { value: v, label: v };
                                })}
                                onChange={value =>
                                    this.setState({
                                        fontstyle: value
                                    })
                                }
                                ref={node => (this.fontstyleRef = node)}
                            />
                        </div>
                        <div className="col-md-4">
                            <Select
                                label="Font weight"
                                options={['100', '200', '300', '400', '500', '600', '700', '800', '900'].map(v => {
                                    return { value: v, label: v };
                                })}
                                defaultValue={this.state.fontweight}
                                onChange={value =>
                                    this.setState({
                                        fontweight: value
                                    })
                                }
                                ref={node => (this.fontweightRef = node)}
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-md-12">
                        <AssetUploader
                            filter=".+\.(woff|ttf|woff2|svg|eot|otf)"
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            hasAccess={this.validateAccess()}
                            metadata={{
                                category: CATEGORIES.FONT,
                                fontfamily: this.state.fontfamily,
                                fontstyle: this.state.fontstyle,
                                fontweight: this.state.fontweight
                            }}
                            onSuccess={() => {
                                this.setState({
                                    fontfamily: '',
                                    fontweight: undefined,
                                    fontstyle: undefined
                                });
                                this.fontstyleRef && this.fontstyleRef.sparkSelect.clearValue();
                                this.fontweightRef && this.fontweightRef.sparkSelect.clearValue();
                            }}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onOpen={this.onResetErrors}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <AssetBrowser
                            displayMode="list"
                            category={CATEGORIES.FONT}
                            filter=".+\.(woff|ttf|woff2|svg|eot|otf)"
                            footerFormatter={this.footerFormatter}
                            setRef={node => (this.browser = node)}
                            hasAccessForDelete={
                                this.props.hasAccessThemes.delete || this.props.hasAccessCustomContent.delete
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

PagesCustomFonts.propTypes = {
    hasAccessThemes: PropTypes.object,
    hasAccessCustomContent: PropTypes.object
};

const mapStateToProps = state => {
    return {
        hasAccessThemes: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        hasAccessCustomContent: checkPermissions(state, ACCESS_POINTS_GROUP.CUSTOM_CONTENT)
    };
};

export default connect(mapStateToProps)(PagesCustomFonts);



// WEBPACK FOOTER //
// ./src/components/assets/PagesCustomFonts.js